import Form from "../../../app/components/Form";
import Input from "../../../app/components/Input";
import AuthNavigation from "../../../app/components/AuthNavigation";
import ToggleVisibilityBtn from "./ToggleVisibilityBtn";

import { Link } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";

function SignUp({
  loggedIn,
  onLogout,
  onMenuClick,
  isMenuOpen,
  menuId,
  onSignup,
  isSendingReq,
  onContactClick,
}) {
  const [email, setEmail] = useState("");
  const [emailError, setEmailError] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  function handleEmailChange(e) {
    const emailRegex =
      /^([a-z0-9_-]+\.)*[a-z0-9_-]+@[a-z0-9_-]+(\.[a-z0-9_-]+)*\.[a-z]{2,6}$/i;
    const isEmailValid = emailRegex.test(e.target.value);
    if (!isEmailValid) {
      setEmailError("Please enter a valid e-mail");
    } else {
      setEmailError("");
    }
    setEmail(e.target.value);
  }

  const [password, setPassword] = useState("");
  const [passwordError, setPasswordError] = useState("");
  function handlePasswordChange(e) {
    if (e.target.value.length < 8) {
      setPasswordError("Password must be at least 8 characters long");
    } else {
      setPasswordError("");
    }
    setPassword(e.target.value);
  }

  const [isFormValid, setIsFormValid] = useState(false);
  useEffect(() => {
    if (email && password && !emailError && !passwordError) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [email, password, emailError, passwordError]);

  function handleSignup(e) {
    e.preventDefault();
    onSignup(email, password);
  }

  function handleVisibilityBtnClick() {
    setIsPasswordVisible(!isPasswordVisible);
  }

  return (
    <section className="sign-up">
      <AuthNavigation
        loggedIn={loggedIn}
        onLogout={onLogout}
        onMenuClick={onMenuClick}
        isMenuOpen={isMenuOpen}
        menuId={menuId}
        onContactClick={onContactClick}
      />
      <div className="sign-up__container">
        <Form
          formName="signup"
          formClassname="form"
          titleClassname="form__title"
          title="Create account"
          titleTag="h1"
          buttonClassname="form__submit-btn"
          buttonText="Sign up"
          isFormValid={isFormValid}
          isSendingReq={isSendingReq}
          onSubmit={handleSignup}
        >
          <Input
            inputLabel="E-mail"
            placeholder="Enter e-mail"
            classname="input__field"
            inputType="text"
            inputValue={email}
            onChange={handleEmailChange}
            isSendingReq={isSendingReq}
            error={emailError}
            inputName="signup email"
          />
          <div className="password-field">
            <Input
              inputLabel="Password"
              placeholder="Enter password"
              classname="input__field input__field_type_password"
              inputType={isPasswordVisible ? "text" : "password"}
              inputValue={password}
              onChange={handlePasswordChange}
              isSendingReq={isSendingReq}
              error={passwordError}
              inputName="signup password"
            />
            <ToggleVisibilityBtn
              isPasswordVisible={isPasswordVisible}
              onVisibilityBtnClick={handleVisibilityBtnClick}
            />
          </div>
        </Form>
        <div className="form__additional-info">
          <p className="form__link-note">Already registered?</p>
          <Link className="form__link" to="/signin">
            Sign in
          </Link>
        </div>
      </div>
    </section>
  );
}

export default SignUp;
